module.exports = "images/nav-desktops-20171010.webp";